'use client';

import { Box, Flex, freddyTheme, Typography } from '@coolblue-development/freddy';
import showApplicationStatus from '@coolblue-development/ga4-events/triggers/VacancyApplicationSubmit/showApplicationStatusTrigger';
import { CheckmarkCircled } from '@coolblue-development/icons';
import { TrackImmediate } from '@coolblue-development/next-analytics/client';
import { Image } from '@coolblue-development/next-image/client';
import { useTranslation } from '@i18n/useTranslation';
import React from 'react';

export const SuccessMessage = () => {
  const { t } = useTranslation('vacancyDetail.applicationForm.successMessage');

  return (
    <>
      <TrackImmediate
        trigger={showApplicationStatus({
          sub_feature: 'successful_application'
        })}
      />
      <Flex direction='column' alignItems='center' sx={{ width: '100%' }} gap={400}>
        <Box>
          <Flex direction='column' alignItems='center' mb={400} gap={400}>
            <CheckmarkCircled size={32} color={freddyTheme.color.font.sentimentPositiveContrast} />
            <Typography
              variant='h2'
              textAlign='center'
              color={freddyTheme.color.font.sentimentPositiveContrast}
              marginBottom={0}
            >
              {t('title')}
            </Typography>
          </Flex>
          <Flex justifyContent='center'>
            <Image
              imageId='597297'
              alt='Celebration with confetti'
              width={700}
              height={189}
              loading='lazy'
              fileCollection='content'
              objectFit='cover'
              sx={theme => ({
                [theme.breakpoint.maxWidth('md')]: {
                  width: 343,
                  height: 135
                }
              })}
            />
          </Flex>
        </Box>
      </Flex>
      <Flex
        sx={{ width: '100%' }}
        direction='column'
        alignItems='center'
        gap={200}
        py={{ xs: 400, md: 600 }}
        backgroundColor={freddyTheme.color.background.secondary}
        borderRadius={{ xs: 100, md: 200 }}
      >
        <Typography
          variant='h5'
          textAlign='center'
          marginBottom={0}
          sx={theme => ({
            [theme.breakpoint.maxWidth('md')]: {
              padding: `0 ${theme.spacing[300]}`
            }
          })}
        >
          {t('text')}
        </Typography>
        <Flex gap={100} direction='column' alignItems='center'>
          <Typography variant='caption' color={freddyTheme.color.font.base} marginBottom={0}>
            {t('additionalText')}
          </Typography>
        </Flex>
      </Flex>
    </>
  );
};
